import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PaymentVoucherPdf from '../components/vouchers/PaymentVoucherPdf'

const PVPrint = () => {
    const {voucherId} = useParams();
    //console.log({voucherId});
    const pv = useSelector(state => state.pv);
    const [voucher, setVoucher] = useState({});
    useEffect(() => {
        const fetchData = async () => {
            try{
                //load current voucher
                const filterList = await pv?.vouchers?.filter((item) => (item.voucherNo === voucherId));
                const filterVoucher = (filterList[0]);
                //load count of vouchers in same project
                const count = (pv?.vouchers?.reduce((count, item) => {
                    if( item.project === filterVoucher.project )
                        count += 1;
                    return count;
                }, 0));

                setVoucher({...filterVoucher, 'projectCount' : count});
            }
            catch(error){
                console.log(error);
            }
        };

        return fetchData();

    }, [pv, voucherId]);

    return (
        <div>
            
            {voucher && Object.entries(voucher).length > 0 && 
                <PaymentVoucherPdf voucher = {voucher} />}
            
        </div>
    )
}

export default PVPrint
